export const MONITOR_SCRIPT = `
(function() {
    "use strict";

    // 数据清理函数 - 移除不可序列化的对象
    function sanitizeData(obj, depth = 0) {
        if (depth > 10) return "[深度限制]";
        
        if (obj === null || obj === undefined) {
            return obj;
        }
        
        if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
            return obj;
        }
        
        if (obj instanceof Error) {
            return {
                name: obj.name,
                message: obj.message,
                stack: obj.stack
            };
        }
        
        if (obj instanceof Request || obj instanceof Response || obj instanceof ReadableStream) {
            return "[不可序列化对象: " + obj.constructor.name + "]";
        }
        
        if (obj instanceof Event) {
            return {
                type: obj.type,
                target: obj.target ? obj.target.tagName || obj.target.constructor.name : null,
                timeStamp: obj.timeStamp
            };
        }
        
        if (Array.isArray(obj)) {
            return obj.map(item => sanitizeData(item, depth + 1));
        }
        
        if (typeof obj === "object") {
            const result = {};
            for (const key in obj) {
                try {
                    if (obj.hasOwnProperty(key)) {
                        const value = obj[key];
                        if (typeof value === "function") {
                            result[key] = "[函数]";
                        } else if (value && typeof value === "object") {
                            // 检查是否是不可序列化的对象
                            if (value instanceof Request || value instanceof Response || 
                                value instanceof ReadableStream || value instanceof AbortController ||
                                value instanceof FormData || value instanceof File) {
                                result[key] = "[不可序列化对象: " + value.constructor.name + "]";
                            } else {
                                result[key] = sanitizeData(value, depth + 1);
                            }
                        } else {
                            result[key] = value;
                        }
                    }
                } catch (e) {
                    result[key] = "[访问错误: " + e.message + "]";
                }
            }
            return result;
        }
        
        return String(obj);
    }

    function reportError(errorData) {
        console.log("准备报告错误:", errorData);
        try {
            // 清理错误数据
            const cleanErrorData = sanitizeData(errorData);
            
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    type: "webcontainer-error",
                    error: cleanErrorData,
                    source: "webcontainer",
                    timestamp: Date.now()
                }, "*");
                console.log("错误已发送到父页面");
            }else if (window.top && window.top !== window) {
                window.top.postMessage({
                    type: "webcontainer-error",
                    error: cleanErrorData,
                    source: "webcontainer",
                    timestamp: Date.now()
                }, "*");
            }
        } catch (e) {
            console.warn("无法发送错误报告:", e);
            // 尝试发送简化版本的错误信息
            try {
                const simplifiedError = {
                    type: errorData.type || "unknown-error",
                    message: String(errorData.message || "未知错误"),
                    timestamp: Date.now()
                };
                
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({
                        type: "webcontainer-error",
                        error: simplifiedError,
                        source: "webcontainer"
                    }, "*");
                }
            } catch (fallbackError) {
                console.error("连简化错误都无法发送:", fallbackError);
            }
        }
    }

    // 全局错误捕获
    window.addEventListener("error", function(event) {
        reportError({
            type: "javascript-error",
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            stack: event.error ? event.error.stack : null,
            timestamp: Date.now()
        });
    }, true);

    // Promise rejection
    window.addEventListener("unhandledrejection", function(event) {
        console.log("捕获到Promise rejection:", event);
        reportError({
            type: "unhandled-rejection",
            message: event.reason ? String(event.reason) : "Unknown rejection",
            stack: event.reason && event.reason.stack ? event.reason.stack : null,
            reason: event.reason,
            timestamp: Date.now()
        });
    });

    // // React错误补充
    // const originalConsoleError = console.error;
    // console.error = function(...args) {
    //     const errorMessage = args.map(arg => {
    //         if (typeof arg === "object") {
    //             try {
    //                 return JSON.stringify(arg, null, 2);
    //             } catch {
    //                 return String(arg);
    //             }
    //         }
    //         return String(arg);
    //     }).join(" ");

    //     if (errorMessage.includes("React") || 
    //         errorMessage.includes("component") || 
    //         errorMessage.includes("render")) {
    //         reportError({
    //             type: "react-error",
    //             message: errorMessage,
    //             timestamp: Date.now()
    //         });
    //     }

    //     originalConsoleError.apply(console, args);
    // };

    // // 网络错误监听
    // const originalFetch = window.fetch;
    // window.fetch = function(...args) {
    //     return originalFetch.apply(this, args).catch(error => {
    //         reportError({
    //             type: "network-error",
    //             message: "Fetch failed: " + error.message,
    //             url: args[0],
    //             timestamp: Date.now()
    //         });
    //         throw error;
    //     });
    // };

    // // 资源加载错误
    // window.addEventListener("error", function(event) {
    //     if (event.target !== window) {
    //         reportError({
    //             type: "resource-error",
    //             message: "Failed to load " + event.target.tagName + ": " + (event.target.src || event.target.href),
    //             element: event.target.tagName,
    //             source: event.target.src || event.target.href,
    //             timestamp: Date.now()
    //         });
    //     }
    // }, true);

})();
`;
